<template>
  <div class="monthdiv">
  <div class="monthIndex">
    <div class="searchBox">
     <h3>Monthly Statement</h3>
     <div class="monthday_box">
        <el-date-picker
          v-model="monthValue"
          type="month"
          @change="changeMonth"
          placeholder="Select Month"
          value-format="yyyy-MM"
          :clearable='false'>
        </el-date-picker>
        <div class="salarySum" >
          <span style="display: inline-block;margin-right: 12px">Total Classes:{{total_classes}}</span>
          <span style="display: inline-block;margin-right: 12px">AS Classes:{{as_classes}}</span>
          <span v-if="isSeesalary==1">Total:${{salarySum}}</span>
        </div>
     </div>
     <div class="flex-info">
       <div class="flex-info mr" v-if="lessonShow">
        <p>Lesson</p>
        <el-date-picker
          v-model="lessonValuetimeRang"
          type="daterange"
          range-separator="-"
          start-placeholder="Select a date"
          end-placeholder="date range"
          :picker-options="lessonpickerOptions"
          value-format="yyyy-MM-dd"
          @change="lessonSearch">
        </el-date-picker>
       </div>
       <div class="flex-info" v-if="enterShow">
        <p>Enter Time</p>
        <el-date-picker
          v-model="enterValuetimeRang"
          type="datetimerange"
          range-separator="-"
          start-placeholder="Select a date"
          end-placeholder="date range"
          :picker-options="enterpickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="enterSearch">
        </el-date-picker>
       </div>
     </div>
     <div>
    <div class="flex-info">
      <div class="flex-info" v-if="leaveShow">
        <p>Leave Time</p>
        <el-date-picker
          v-model="leaveValuetimeRang"
          type="datetimerange"
          range-separator="-"
          start-placeholder="Select a date"
          end-placeholder="date range"
          :picker-options="leavepickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="leaveSearch">
        </el-date-picker>
      </div>

    </div>
     </div>
    </div>
    <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="">All</el-menu-item>
      <el-menu-item index="1">Absence</el-menu-item> -->
      <!-- <el-menu-item index="2">Leave Early</el-menu-item>
      <el-menu-item index="3">Late</el-menu-item> -->
      <!-- <el-menu-item index="4">Present</el-menu-item> -->
    <!-- </el-menu> -->
     <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="">H1</el-menu-item>
      <el-menu-item index="1">H2</el-menu-item>
    </el-menu>
    <el-table
      :data="lessonList"
      tooltip-effect="dark" header-row-class-name="month_header" header-cell-class-name="month_header"
      style="width: 100%">
      <el-table-column
      label="Date"
      prop="date">
      </el-table-column>
      <el-table-column
      label="Course Information"
      prop="course_information">
      </el-table-column>
      <el-table-column
      label="Length Of Time">
          <template slot-scope="scope">
            <span>{{scope.row.start_time}} - {{scope.row.end_time}}</span>
          </template>
      </el-table-column>
      <el-table-column
      label="Finish Type"
      prop="finish_status">
      </el-table-column>
      <el-table-column
      v-if="isSeesalary==1"
      label="Amount ($)"
      prop="amount">
      </el-table-column>
      <!-- <el-table-column
      label="Finish Type">
          <template slot-scope="scope">
              <p
              v-for="(item,index) in scope.row.user_in_out" :key="index" v-html="item.entertime?item.entertime:'N/A'"></p>
          </template>
      </el-table-column>
      <el-table-column
      label="Amount($)">
          <template slot-scope="scope">
              <p
              v-for="(item,index) in scope.row.user_in_out" :key="index" v-html="item.outtime?item.outtime:'N/A'"></p>
          </template>
      </el-table-column> -->
      <!-- <el-table-column
      label="STATUS" align="center"
       >
          <template slot-scope="scope">
              <p class='text-ellipsis' style="display: inline-block" :title="scope.row.status" :class="scope.row.title == 'Absence' ? 'Absence':'Present'">
                <span>{{scope.row.title}}</span>
              </p>
          </template>
      </el-table-column> -->
<!--      <el-table-column-->
<!--      label="LESSON EARNED"-->
<!--      prop="lesson_earned" width="150">-->
<!--      </el-table-column>-->

  </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pagenum"
      :page-size="pagesize"
      layout="prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      monthltType:1,
      salarySum:'',
      isSeesalary:'',
      // recordData: {},
      statusjson: [
        {
          dot: '#828282',
          bgcolor: '#E8E8E8',
          color: '#424443',
          title: 'Absence',
          id: 1
        },
        {
          dit: '#FA7900',
          bgcolor: '#FDCEAF',
          color: '#F26942',
          title: 'Leave Early',
          id: 2
        },
        {
          dot: '#386EA0',
          bgcolor: '#E1E7FC',
          color: '#145980',
          title: 'Late',
          id: 3
        },
        {
          dot: '#38A06C',
          bgcolor: '#E1FCEF',
          color: '#14804A',
          title: 'Present',
          id: 4
        }
      ],
      classTypeData: [],

      total: 0,
      pagenum: 1, // 当前页码
      pagesize: 10, // 每页显示条数

      monthValue: '', // 当前月份
      // pickerMonth: {
      //     disabledDate (time) {
      //     // 此条为设置用户选择今天之前的日期，包含今天。
      //     return time.getTime() > (Date.now());
      //     // 此条为设置禁止用户选择今天之前的日期，不包含今天。
      //     // return time.getTime() < (Date.now() - (24 * 60 * 60 * 1000))
      //     }
      // },
      lessonList: [],
      activeIndex: '',
      statusArr: [],
      subject_id: [],
      class_type: [],
      options: [
        {
          value: 'Subject',
          label: 'Subject',
          children: []
        },
        {
        //   value:'All',
        //   label: 'All',
        // },{
          value: 'lesson',
          label: 'Date'
        },
       /*  {
          value: 'enter',
          label: 'Enter Time'
        }, {
          value: 'leave',
          label: 'Leave Time'
        // }, {
        //   value: 'status',
        //   label: 'Status',
        //   children: [{
        //     value: '1',
        //     label: 'Absence'
        //   }, {
        //     value: '2',
        //     label: 'Leave Early'
        //   }, {
        //     value: '3',
        //     label: 'Late'
        //   }, {
        //     value: '4',
        //     label: 'Present'
        //   }]
        }, */
         {
          value: 'classType',
          label: 'Class Type',
          children: []
        }],
      selectArr: [], // 多选矿数据

      lessonValuetimeRang: '',
      lessonShow: false,
      lessonpickerOptions: { // 限制收货时间不让选择今天以前的
        disabledDate (time) {
          // let startTime = '2022-04-01'
          // let day = new Date(this.monthValue.split('-')[0],this.monthValue.split('-')[1],0);
          // let endTime = year + '' + month + '' + day.getDate();
          // console.log(startTime,'startTime');
          // console.log(endTime ,'endTime ');
          return time.getTime() < '2022-04-01'
        }
      },
      enterValuetimeRang: '',
      enterShow: false,
      enterpickerOptions: { // 限制收货时间不让选择今天以前的
        disabledDate (time) {
          return time.getTime() < (Date.now() - (24 * 60 * 60 * 1000))
        }
      },
      leaveValuetimeRang: '',
      leaveShow: false,
      leavepickerOptions: { // 限制收货时间不让选择今天以前的
        disabledDate (time) {
          return time.getTime() < (Date.now() - (24 * 60 * 60 * 1000))
        }
      },
      as_classes:'',
      total_classes:''

    }
  },
  created () {
    // const start = new Date();
    // this.monthValue = start.getMonth()
    let date = new Date()
    let month = (date.getMonth() + 1).toString().padStart(2, '0')
    let year = date.getFullYear()
    let startTime = year + '-' + month
    this.monthValue = startTime
    console.log(this.monthValue)
    this.getClassTypeData()
    this.getSubjectData()
  },
  methods: {
    // 获取课程类型
    getClassTypeData () {
      this.$http.get('/tutor/api/getClassType?time=' + this.utils.timeZone()).then((res) => {
        if (res.data.code == 200) {
          this.classTypeData = res.data.data
          this.classTypeData.map(item => {
            this.options[this.options.length - 1].children.push({
              value: item.id,
              label: item.tags
            })
          })
          // this.getList()
          this.gettableList()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取科目数据
    getSubjectData () {
      this.$http.get('/tutor/api/getSubjectList?pagesize=999&page=1').then((res) => {
        if (res.data.code == 200) {
          this.subjectData = res.data.data
          this.subjectData.map(item => {
            this.options[0].children.push({
              value: item.id,
              label: item.title
            })
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    gettableList(){
      this.$http.get('/tutor/api/teacherSalaryList?search_date=' + this.monthValue + '&pagesize=' + this.pagesize + '&page=' + this.pagenum+ '&type=' + this.monthltType).then((res) => {
        if (res.data.code == 200) {
          this.total = res.data.data.total
          this.lessonList = res.data.data.data.data;
          this.salarySum=res.data.data.data.salary_sum
          this.isSeesalary=res.data.data.data.is_see_salary
          this.total_classes = res.data.data.data.total_classes
          this.as_classes = res.data.data.data.as_classes
          // this.setdata()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取列表数据
    getList () {
      let form = {
        lesson_start_at: this.lessonValuetimeRang ? this.lessonValuetimeRang[0] + ' 00:00:00' : '',
        lesson_end_at: this.lessonValuetimeRang ? this.lessonValuetimeRang[1] + ' 23:59:59' : '',
        enter_start_at: this.enterValuetimeRang ? this.enterValuetimeRang[0] : '',
        enter_end_at: this.enterValuetimeRang ? this.enterValuetimeRang[1] : '',
        leave_start_at: this.leaveValuetimeRang ? this.leaveValuetimeRang[0] : '',
        leave_end_at: this.leaveValuetimeRang ? this.leaveValuetimeRang[1] : '',
        month: this.monthValue,
        class_status: this.activeIndex,
        class_type: this.class_type,
        subject_id: this.subject_id,
        pagesize: this.pagesize,
        page: this.pagenum,
        time: this.utils.timeZone()
      }
      this.$http.post('/tutor/api/getMonthlyStatement', form).then((res) => {
        if (res.data.code == 200) {
          this.total = res.data.data.total
          this.lessonList = res.data.data.lesson_info
          this.setdata()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 切换页数
    handleCurrentChange (val) {
      this.pagenum = val
      // this.getList()
      this.gettableList()
    },
    // 切换状态
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
      this.activeIndex = key
      this.statusArr = []
      this.statusArr.push(this.activeIndex)
      this.pagenum = 1
      if (key == '1') {
        this.monthltType= 2
      } else {
        this.monthltType= 1
      }
      // this.getList()
      this.gettableList()
    },
    setdata () {
      this.lessonList.map(item => {
        this.statusjson.map(s_item => {
          if (item.status == s_item.id) {
            item = Object.assign(item, s_item)
          }
        })
        // this.classTypeData.map(c_item => {
        //   if (item.course_type == c_item.id) {
        //     item.classTypeTags = c_item.tags
        //   }
        // })
      })
    },
    // 多选选择
    changeFilter () {
      console.log(this.selectArr)
      this.leaveShow = false
      this.enterShow = false
      this.lessonShow = false
      this.subject_id = []
      this.statusArr = []
      this.class_type = []
      if (this.selectArr.length > 0) {
        this.selectArr.map(item => {
          if (item.length == 1 && item[0].indexOf('lesson') > -1) {
            this[item[0] + 'Show'] = true
          }
          if (item.length == 1 && item[0].indexOf('enter') > -1) {
            this[item[0] + 'Show'] = true
          }
          if (item.length == 1 && item[0].indexOf('leave') > -1) {
            this[item[0] + 'Show'] = true
          }
          if (item.length == 2 && item[0] == 'Subject') {
            this.subject_id.push(item[1])
          }
          if (item.length == 2 && item[0] == 'status') {
            this.statusArr.push(item[1])
          }
          if (item.length == 2 && item[0] == 'classType') {
            this.class_type.push(item[1])
          }
          // if(item.length==1&&item[0]=='leave'){
          //     this.leaveShow = true
          // }else{
          //   this.leaveShow = false
          // }
        })
      } else {
        this.leaveShow = false
        this.enterShow = false
        this.lessonShow = false
        this.subject_id = []
        this.statusArr = []
        this.class_type = []
      }
      // this.getList()
      this.gettableList()
    },
    goBack () {
      this.$router.push({
        path: '/index'
      })
    },

    // 切换月份
    changeMonth (value) {
      console.log(value, 'value')
      this.monthValue = value
      // this.getList()
      this.gettableList()
      // let date = new Date(value);
      // let month = (date.getMonth() + 1).toString().padStart(2,'0');
      // let year = date.getFullYear();
      // let startTime = year + '' + month + '01';
      // let day = new Date(year,month,0);
      // let endTime = year + '' + month + '' + day.getDate();
      // console.log(startTime,'startTime');
      // console.log(endTime ,'endTime ');
    },
    lessonSearch (value) {
      console.log(value)
      // this.getList()
      this.gettableList()
    },
    enterSearch (value) {
      console.log(value)
      // this.getList()
      this.gettableList()
    },
    leaveSearch (value) {
      console.log(value)
      // this.getList()
      this.gettableList()
    }
  }
}
</script>
<style lang="less" scoped>
.monthdiv{
  width: 95%;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
}
  .monthIndex{
    .searchBox{
      h3{
        font-size:33px;
        margin-bottom:30px;
      }
    }
    .mr{
      margin-right: 40px;
    }
    .text-ellipsis{
      //border-radius: 4px;
      //padding:0px 15px;
      //display: inline-flex;
      //justify-content: center;
      //align-items: center;
      //font-size: 12px;
      width: 115.08px;
      height: 34px;
      border-radius: 8px;
      /* 自动布局 */
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 6px 16px;
      gap: 0px 10px;
      flex-wrap: wrap;
      align-content: center;
      box-sizing: border-box;
    }
    .dot{
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 5px;
      margin-right:8px;
    }
    .flex-info{
      display: flex;
      align-items: center;
      margin:10px 0;
    }
    /deep/ .el-table{
      margin-top:20px;
    }
    /deep/ .el-menu{
      margin-top:20px;
      border-bottom:none;
      background-color:transparent;
       > .el-menu-item:not(.is-disabled):hover,  > .el-menu-item:not(.is-disabled):focus{
         background: transparent;
      }
      .el-menu-item.is-active{
        color: #FF6440;
        font-size: 14px;
      }
    }

    // 日历
    /deep/ .el-date-editor--daterange{
      width:300px;
      height:40px;
      border:none;
      border-bottom: 1px solid #a5a5a5;
      border-radius: 0;
      input,span{
        line-height: 35px;
      }
      input{
        width: 30%;
        text-align: left;
      }
      .el-range-separator{
        color:#979797;
        font-size: 14px;
        font-family: Arial;
      }
      .el-icon-date,.el-range__close-icon{
        display: none;
      }

    }
    /deep/ .el-cascader{
      width:600px;
    }
    .backA{
      font-size: 20px;
      display: inline-block;
      cursor: pointer;
    }
  }
  /deep/.month_header{
    background: #F9FAFB !important;
    height: 40px !important;
  }
  .Absence{
    background: rgba(255, 144, 77, 0.2);
    color: #FF6B4A;
    border: 1px solid #FF6B4A;
  }
  .Present{
    background: rgba(41, 206, 115, 0.2);
    color: #29CE73;
    border: 1px solid #29CE73;
  }
  .monthday_box{
    position: relative;
    .salarySum{
      position: absolute;
      right: 0;
      top: 5px;
      font-size: 22px;
      color: orange;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/MonthlyStatement.vue